export const maritalStatuses = [
  {
    value: 'SINGLE',
    label: 'Single',
  },
  {
    value: 'ENGAGED',
    label: 'Engaged',
  },
  {
    value: 'MARRIED',
    label: 'Married',
  },
  {
    value: 'DIVORCED',
    label: 'Divorced',
  },
  {
    value: 'WIDOWED',
    label: 'Widowed',
  },
];
